// extracted by mini-css-extract-plugin
export default {"header-profile":"styles_header-profile__jSooh"};